<body>
    <div>
        <table class="table2">
            <thead>
                <th class="corlinha">
                    Janelas <abbr style="color: #0159e6; font-weight: bold;">SLA</abbr> Direto
                </th>
            </thead>
        </table>
        <div class="table2">
            <!-- <button (click)="abrirTabela('seg')" class="button-spacing"
                [ngClass]="{'clicked': clickedButtons['seg']}">Segunda-Feira</button>
            <button (click)="abrirTabela('ter')" class="button-spacing"
                [ngClass]="{'clicked': clickedButtons['ter']}">Terça-Feira</button>
            <button (click)="abrirTabela('qua')" class="button-spacing"
                [ngClass]="{'clicked': clickedButtons['qua']}">Quarta-Feira</button>
            <button (click)="abrirTabela('qui')" class="button-spacing"
                [ngClass]="{'clicked': clickedButtons['qui']}">Quinta-Feira</button>
            <button (click)="abrirTabela('sex')" class="button-spacing"
                [ngClass]="{'clicked': clickedButtons['sex']}">Sexta-Feira</button> -->
            <!-- <div class="totais"> -->
                <label class="totais">Total Fornecedores: <abbr style="color: #0159e6; font-weight: bold;">{{
                    totalFornecedores }}</abbr></label>
            <!-- </div> -->
            <button (click)="inserirNova()" class="button-spacing newViagem">Inserir viagem</button>
           
                <!-- <input [disabled]="true" type="text" name="totalFornecedores" [(ngModel)]="totalFornecedores" class="modal-input1"> -->
                <!-- <label class="totais">Total MU's: <abbr style="color: #0159e6; font-weight: bold;">{{ totalMU
                        }}</abbr></label> -->
                <!-- <input [disabled]="true" type="text" name="totalMU" [(ngModel)]="totalMU" class="modal-input1"> -->
            <div class="table2">
                <table>
                    <thead>
                        <tr>
                            <th class="auto-width">
                                Fornecedor
                            </th>
                            <th class="auto-width">
                                Quantidade de Entregas
                            </th>
                            <th class="auto-width">
                                Horários
                            </th>
                            <th class="auto-width">
                                Ponto de Descarga
                            </th>
                            <th class="auto-width">
                                Anotações
                            </th>
                            <th class="auto-width">
                                Editar
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngFor="let item of programacaoDiretasFiltradas">
                            <tr>
                                <td>{{ item.fornecedor }}</td>
                                <td>{{ item.qtdEntregas }}</td>
                                <td>
                                    <ng-container *ngFor="let horario of item.horarios">
                                        <div>{{ horario.hora }}</div>
                                    </ng-container>
                                </td>
                                <td>{{ item.pontoDescarga }}</td>
                                <td>{{ item.anotacoes }}</td>
                                <td>
                                    <i-feather name="edit" (click)="editDialog(item)"></i-feather>
                                    <i-feather name="delete" (click)="deleteItem(item.ID)"
                                        class="button-spacing"></i-feather>
                                </td>
                            </tr>
                        </ng-container>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</body>

<clr-modal [(clrModalOpen)]="dialogOpen" [clrModalSize]="'md'" class="dialog-container">
    <h3 class="modal-title">Ajuste de Programação</h3>
    <div class="modal-body">
        <form class="inputs">
            <table class="table2000">
                <tr>
                    <td>
                        <label class="modal-label">Fornecedor</label>
                        <input type="text" name="fornecedor" [(ngModel)]="item.fornecedor" class="modal-input1">
                    </td>
                    <td>
                        <label class="modal-label">Quantidade de entregas</label>
                        <input type="number" name="qtdEntregas" [(ngModel)]="item.qtdEntregas"
                            (input)="updateHorarios()" class="modal-input1">
                    </td>
                    <td>
                        <label class="modal-label">Horários</label>
                        <table>
                            <tr *ngFor="let horario of item.horarios; let i = index">
                                <td>
                                    <input type="time" name="hora{{i}}" [(ngModel)]="horario.hora" class="modal-input1">
                                </td>
                                <td>
                                    <button type="button" (click)="removerHorario(i)">Remover</button>
                                </td>
                            </tr>
                        </table>
                    </td>
                    <td>
                        <label class="modal-label">Ponto de Descarga</label>
                        <input type="text" name="pontoDescarga" [(ngModel)]="item.pontoDescarga" class="modal-input1">
                    </td>
                </tr>
                <!-- <tr>
                    <td>
                        <label class="modal-label">WEB Stars</label><br>
                        <!-- <td> --
                            <select name="statusWebStars" [(ngModel)]="item.statusWebStars">
                              <option value="OK">OK</option>
                              <option value="Not OK">Not OK</option>
                            </select>
                          <!-- </td>
                        <input type="string" name="statusWebStars" [(ngModel)]="item.statusWebStars"
                            class="modal-input1"> --
                    </td>
                    <td>
                        <label class="modal-label">Confirmação</label><br>
                        <select name="confirmacao" [(ngModel)]="item.confirmacao">
                            <option value="OK">OK</option>
                            <option value="Not OK">Not OK</option>
                          </select>
                        <!-- <input type="string" name="confirmacao" [(ngModel)]="item.confirmacao" class="modal-input1"> --
                    </td>
                    <td>
                        <label class="modal-label">Descrição</label><br>
                        <!-- <input type="string" name="descricao" [(ngModel)]="item.descricao" class="modal-input1"> --
                        <select name="descricao" [(ngModel)]="item.descricao">
                            <option value="DIRETO">DIRETO</option>
                            <option value="INDIRETO">INDIRETO</option>
                          </select>
                    </td>
                    <td>
                        <label class="modal-label">MP Name</label>
                        <input type="string" name="mpName" [(ngModel)]="item.mpName" class="modal-input1">
                    </td>
                </tr>
                <tr>
                    <td>
                        <table class="table2000">
                            <tr>
                                <td>
                                    <label class="modal-label">Anotações</label><br>
                                    <input type="text" name="anotacoes" [(ngModel)]="item.anotacoes" class="modal-input1 notes">
                                </td>
                            </tr>
                            <tr>
                                <td colspan="3">Contatos</td>
                                <td>
                                    <button type="button" (click)="adicionarContato()">Adicionar Contato</button>
                                </td>
                            </tr>
                            <tr *ngFor="let contato of item.contatos; let i = index">
                                <td>
                                    <label class="modal-label">Nome</label>
                                    <input type="text" name="nome{{i}}" [(ngModel)]="contato.nome" class="modal-input1">
                                </td>
                                <td>
                                    <label class="modal-label">Telefone</label>
                                    <input type="text" name="telefone{{i}}" [(ngModel)]="contato.telefone"
                                        class="modal-input1">
                                </td>
                                <td>
                                    <label class="modal-label">Email</label>
                                    <input type="text" name="email{{i}}" [(ngModel)]="contato.email"
                                        class="modal-input1">
                                </td>
                                <td>
                                    <button type="button" (click)="removerContato(i)">Remover</button>
                                </td>
                            </tr>
                        </table>
                    </td>
                </tr> -->
            </table>
            <div class="modal-div">
                <button class="modal-button" type="button" (click)="salvar2(item)">Save</button>
                <button class="modal-button" type="button" (click)="cancel()">Cancel</button>
            </div>
        </form>
    </div>
</clr-modal>

<div *ngIf="isLoading" class="spinner-overlay">
    <div class="spinner">
        <mat-spinner></mat-spinner>
    </div>
</div>